import {
  HandleValidDate,
  FormatDate,
  FormatDateDDMMMYYYY,
} from "helpers/method_helper"

const HealthdayMonitoringColumnsForExport = [
  {
    Header: "Centre",
    accessor: "Centre",
  },
  {
    Header: "First Name",
    accessor: "FirstName",
  },
  {
    Header: "Last Name",
    accessor: "LastName",
  },
  {
    Header: "Gender",
    accessor: "Gender",
  },
  {
    Header: "Ethnicity",
    accessor: "Ethnicity",
  },
  {
    Header: "Date of Birth",
    accessor: row =>
      row.DateOfBirth ? FormatDateDDMMMYYYY(row.DateOfBirth) : "",
  },
  {
    Header: "Address",
    accessor: "Address",
  },
  {
    Header: "Area",
    accessor: "Area",
  },
  {
    Header: "Postcode",
    accessor: "Postcode",
  },
  {
    Header: "Mobile",
    accessor: "Mobile",
  },
  {
    Header: "Contact Number",
    accessor: "ContactNumber",
  },
  {
    Header: "Mobile Network",
    accessor: "MobileNetwork",
  },
  {
    Header: "Phone Contract",
    accessor: "PhoneContract",
  },
  {
    Header: "NDB Number",
    accessor: "NDBNumber",
  },
  {
    Header: "NDB Network Type",
    accessor: "NDBNetworkType",
  },
  {
    Header: "NDB Added",
    accessor: "NDBAdded",
  },
  {
    Header: "NDB Registered",
    accessor: row => (row.NDBRegistered ? "Yes" : "No"),
  },
  {
    Header: "MMP Group",
    accessor: "MMPGroup",
  },
  {
    Header: "Smoke Alarm",
    accessor: row => (row.SmokeAlarm ? "Yes" : "No"),
  },
  {
    Header: "Email",
    accessor: "EmailAddress",
  },
  {
    Header: "Created By",
    accessor: "CreatedByName",
  },
  {
    Header: "Created Date",
    accessor: row =>
      row.CreatedDate ? FormatDateDDMMMYYYY(row.CreatedDate) : "",
  },
]

export { HealthdayMonitoringColumnsForExport }
